import { createFileRoute } from '@tanstack/react-router'
import { InstagramPostTool } from '~/features/crossposting/components/instagram-post-tool'

export const Route = createFileRoute('/dashboard/crossposting/$listingId/instagram')({
  component: InstagramRoute,
})

function InstagramRoute() {
  const { listingId } = Route.useParams()
  return <InstagramPostTool listingId={listingId} />
}
